import { render, staticRenderFns } from "./RSummaryTable.vue?vue&type=template&id=6e0db716&scoped=true&"
import script from "./RSummaryTable.vue?vue&type=script&lang=js&"
export * from "./RSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./RSummaryTable.vue?vue&type=style&index=0&id=6e0db716&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0db716",
  null
  
)

export default component.exports